// extracted by mini-css-extract-plugin
export default {"table":"QurealTableNew_table__LCoge","resize_handle":"QurealTableNew_resize_handle__JT08S"};